import { useDispatch } from "react-redux";
import { getLogger } from "../modules/logs";

const useLogger = () => {
  return getLogger(useDispatch());
};

export default useLogger;
